import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates']['GET'];

type Input = {
  page: number;
  perPage?: number;
  searchTerm?: string;
};

type Output = ThisApi['response'];

const getDynamicPdfTemplates = async ({ page, perPage, searchTerm }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.get('/dynamic-pdf-templates', {
      params: {
        page,
        perPage,
        searchTerm,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dynamic PDF templates:', error);
    throw error;
  }
};

export default getDynamicPdfTemplates;
